const BackArrow = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" className={className}>
    <path
      d="m22 11h-17.586l5.293-5.293a1 1 0 1 0 -1.414-1.414l-7 7a1 1 0 0 0 0 1.414l7 7a1 1 0 0 0 1.414-1.414l-5.293-5.293h17.586a1 1 0 0 0 0-2z"
      fill="currentColor"
    />
  </svg>
);

export default BackArrow;
